import React from 'react';
import ReportingEventsAttendancePage from '../components/ReportingEventsAttendancePage';

const ReportingEventsAttendanceApp = (props) => (
  <ReportingEventsAttendancePage {...props} />
);

export default ReportingEventsAttendanceApp;
